import { IMAGES } from "@/lib/site";

export const ServiceRadius = () => (
  <section id="service-radius" className="py-24 bg-white border-b border-stone-200" data-testid="service-radius-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-6">
          <h2 className="text-xs font-bold uppercase tracking-widest text-amber-800 mb-2">Central Ohio Base</h2>
          <p className="font-display text-3xl font-bold text-stone-950 mb-4">Dublin Headquarters, Regional Response</p>
          <p className="text-stone-600 leading-relaxed mb-6" data-testid="service-coverage-text">
            Centrally positioned in Dublin to provide rapid mobilization throughout Franklin County, Delaware County, Union County, and the broader Columbus metropolitan area.
          </p>
          <div className="text-xs font-semibold text-stone-700 space-y-2">
            <p>▪ Dublin · Columbus · Hilliard · Upper Arlington · Powell · Marysville</p>
            <p>▪ Fast field turnaround for staking and boundary investigations</p>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="aspect-[16/10] rounded-xl border border-stone-300 relative overflow-hidden flex flex-col justify-between p-6" data-testid="service-map">
            <img
              src={IMAGES.map}
              alt="Columbus, Ohio cityscape — Diamond V service area"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-stone-950/30 via-transparent to-stone-950/50"></div>
            <div className="relative z-10 flex items-center justify-between">
              <span className="text-xs font-bold bg-stone-900 text-white px-3 py-1 rounded shadow-sm">Dublin, OH Hub</span>
              <span className="text-xs font-semibold text-white bg-stone-900/60 px-2 py-1 rounded">Central Ohio Service Perimeter</span>
            </div>
            <div className="relative z-10 bg-white/90 p-3 rounded-lg border border-stone-200 text-xs text-stone-800 font-medium">
              Direct mobilization across Central Ohio commercial &amp; residential development corridors.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
